export default {
  'Black-Acquisition': {
    'x': 2,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Black-Circle': {
    'x': 66,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Black-Compass-Up': {
    'x': 130,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Black-DataCenterProject': {
    'x': 194,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Black-Multi-Family': {
    'x': 258,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Blue-Balloon': {
    'x': 322,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Brown-Acquisition': {
    'x': 386,
    'y': 2,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Brown-Circle': {
    'x': 2,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Brown-Compass-Up': {
    'x': 66,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Brown-DataCenterProject': {
    'x': 130,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Cyan-Balloon': {
    'x': 194,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Darker-Blue-Balloon': {
    'x': 258,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Darker-Blue-Portfolio': {
    'x': 322,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Gray-Acquisition': {
    'x': 386,
    'y': 66,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Gray-Balloon': {
    'x': 2,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Gray-Circle': {
    'x': 66,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Gray-Compass-Up': {
    'x': 130,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Gray-DataCenterProject': {
    'x': 194,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Gray-Multi-Family': {
    'x': 258,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Green-Balloon': {
    'x': 322,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Green-Compass-Up': {
    'x': 386,
    'y': 130,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Orange-Acquisition': {
    'x': 2,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Orange-Balloon': {
    'x': 66,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Orange-Circle': {
    'x': 130,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Orange-Compass-Up': {
    'x': 194,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Orange-DataCenterProject': {
    'x': 258,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Orange-Multi-Family': {
    'x': 322,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Purple-Balloon': {
    'x': 386,
    'y': 194,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Red-Balloon': {
    'x': 2,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Yellow-Acquisition': {
    'x': 66,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Yellow-Balloon': {
    'x': 130,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Yellow-Circle': {
    'x': 194,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Yellow-Compass-Up': {
    'x': 258,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Yellow-DataCenterProject': {
    'x': 322,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Yellow-Multi-Family': {
    'x': 386,
    'y': 258,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  'Blue-Balloon-Flat': {
    'x': 2,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'LightBlue-Balloon-Flat': {
    'x': 66,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Red-Balloon-Flat': {
    'x': 130,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Green-Balloon-Flat': {
    'x': 194,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Purple-Balloon-Flat': {
    'x': 258,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Yellow-Balloon-Flat': {
    'x': 322,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 64,
  },
  'Blue-Portfolio-Flat': {
    'x': 386,
    'y': 322,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
  // The comp picker's "added" check, drawn beside a marker rather than standing on the map itself.
  'Added-Badge': {
    'x': 2,
    'y': 386,
    'width': 64,
    'height': 64,
    'anchorX': 32,
    'anchorY': 32,
  },
};
